import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LocalSettingsService {
  constructor() {}

  /**
   * Deletes the local storage, session storage
   */
  clearBrowserData() {
    localStorage.clear();
    sessionStorage.clear();
  }

  getLanguage(): string {
    if (localStorage) {
      return localStorage.language || "fr";
    } else {
      return "fr";
    }
  }

  setLanguage(language: string) {
    if (localStorage) {
      localStorage.language = language;
    }
  }

  /**
   * Stores the URL so we can redirect after signing in.
   */
  public getRedirectUrl(): string {
    if (sessionStorage) {
      return sessionStorage.getItem("redirectUrl");
    }
    return null;
  }

  public setRedirectUrl(url: string): void {
    if (sessionStorage) {
      sessionStorage.setItem("redirectUrl", url);
    }
  }

  public removeRedirectUrl(): void {
    sessionStorage.removeItem("redirectUrl");
  }
  public setClearCache(): void {
    if (sessionStorage) {
      console.log("Set item enableCacheReload");
      sessionStorage.setItem("enableCacheReload", "true");
    }
  }
  public getClearCache(): string {
    if (sessionStorage) return sessionStorage.getItem("enableCacheReload");
  }
}
